export default function TagListSkeleton() {
	return (
		<div className="space-y-2">
			{Array.from({ length: 5 }).map((_, tagIndex) => (
				<div key={tagIndex} className="bg-white rounded-xl border border-gray-200 overflow-hidden animate-pulse">
					<div className="p-4 flex items-center justify-between">
						<div className="flex-1">
							<div className="flex items-center gap-3">
								<div className="h-4 w-28 bg-gray-200 rounded" />
								<div className="h-3 w-16 bg-gray-100 rounded" />
							</div>
							<div className="h-3 w-40 bg-gray-100 rounded mt-1.5" />
						</div>
					</div>
				</div>
			))}
		</div>
	);
}
